export default "__VITE_ASSET__B06Bsw4v__"